<template>
    <div class="app-container">
        <jf-table
            :loading="loading"
            :columns="tableColumn"
            :data="dataList"
            :toolbar-config="tableToolbar"
            :query-params="queryParams"
            @checkbox-change="checkboxChangeEvent"
            @page-change="handlePageChange"
            :total="total"
            @change="tableChange"
            @handleQuery="handleQuery"
        >
            <template slot="query_qarams_item">
                <el-form-item label="学生" prop="student_no">
                    <student-select
                        v-model="queryParams.student_no"
                        placeholder="请选择学生"
                        valueField="no"
                        size="small"
                    />
                </el-form-item>
                <el-form-item label="学期" prop="turn_no">
                    <turn-select
                        v-model="queryParams.turn_no"
                        placeholder="请选择学期"
                        valueField="no"
                        size="small"
                    />
                </el-form-item>
                <el-form-item label="课程类别" prop="category">
                    <dict-select
                                v-model="queryParams.category"
                                placeholder="请选择课程类别"
                                type="stuc_course_category"
                            />
                </el-form-item>
                <el-form-item label="课程代码" prop="course_no">
                    <el-input
                        v-model="queryParams.course_no"
                        placeholder="请输入课程代码"
                        clearable
                        size="small"
                    />
                </el-form-item>
                <el-form-item label="课程名称" prop="course_name">
                    <el-input
                        v-model="queryParams.course_name"
                        placeholder="请输入课程名称"
                        clearable
                        size="small"
                    />
                </el-form-item>
                <el-form-item label="等级" prop="level">
                    <dict-select
                                v-model="queryParams.level"
                                placeholder="请选择成绩等级"
                                type="stuc_course_level"
                            />
                </el-form-item>
                <el-form-item label="通过" prop="pass">
                    <dict-select
                                v-model="queryParams.pass"
                                placeholder="请选择是否通过"
                                type="sys_yes_no"
                            />
                </el-form-item>
                <el-form-item label="重修" prop="retake">
                    <dict-select
                                v-model="queryParams.retake"
                                placeholder="请选择是否重修"
                                type="sys_yes_no"
                            />
                </el-form-item>
            </template>
            <template slot="toolbar_btn_left">
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    size="mini"
                    @click="handleAdd"
                    v-hasPermi="['/stuc/stucurriculumscore/add']"
                    >新增</el-button
                >

                <el-button
                    type="success"
                    icon="el-icon-edit"
                    size="mini"
                    :disabled="single"
                    @click="handleUpdate"
                    v-hasPermi="['/stuc/stucurriculumscore/get', '/stuc/stucurriculumscore/edit']"
                    >修改</el-button
                >

                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    :disabled="multiple"
                    @click="handleDelete"
                    v-hasPermi="['/stuc/stucurriculumscore/del']"
                    >删除</el-button
                >

                <el-button
                    type="warning"
                    size="mini"
                    @click="handleImport"
                    v-hasPermi="['/stuc/stucurriculumscore/import']"
                >
                    <i class="iconfont icon-daoru_o"></i>
                    导入
                </el-button>

                <el-button
                    class="btn-orange"
                    size="mini"
                    @click="handleExport"
                    v-hasPermi="['/stuc/stucurriculumscore/export']"
                >
                    <i class="iconfont icon-daochu_o"></i>
                    导出
                </el-button>
            </template>
            <template slot="toolbar_btn_row" slot-scope="{ row }">
                <el-button
                    size="mini"
                    type="text"
                    icon="el-icon-edit"
                    @click.stop="handleUpdate(row)"
                    >修改
                </el-button>
                <el-button
                    size="mini"
                    type="text"
                    icon="el-icon-delete"
                    @click.stop="handleDelete(row)"
                    >删除
                </el-button>
            </template>
        </jf-table>
        
        <el-dialog
            :close-on-click-modal="false"
            :title="title"
            :visible.sync="open"
            width="800px"
            append-to-body
        >
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                label-width="100px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="学生" prop="student_no">
                            <student-select
                                v-model="form.student_no"
                                :defaultLabel="form.student_name"
                                placeholder="请选择学生"
                                valueField="no"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="学期" prop="turn_no">
                            <turn-select
                                v-model="form.turn_no"
                                :defaultLabel="form.turn_no"
                                placeholder="请选择学期"
                                valueField="no"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="课程类别" prop="category">
                            <dict-select
                                        v-model="form.category"
                                        placeholder="请选择课程类别"
                                        type="stuc_course_category"
                                    />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="课程代码" prop="course_no">
                            <el-input
                                v-model="form.course_no"
                                placeholder="请输入课程代码"
                                clearable
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="课程名称" prop="course_name">
                            <el-input
                                v-model="form.course_name"
                                placeholder="请输入课程名称"
                                clearable
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="课程学分" prop="credit">
                            <el-input
                                v-model="form.credit"
                                placeholder="请输入课程学分"
                                clearable
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="课程成绩" prop="score">
                            <el-input
                                v-model="form.score"
                                placeholder="请输入课程成绩"
                                clearable
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="等级" prop="level">
                            <dict-select
                                        v-model="form.level"
                                        placeholder="请选择成绩等级"
                                        type="stuc_course_level"
                                    />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="通过" prop="pass">
                            <dict-select
                                        v-model="form.pass"
                                        placeholder="请选择是否通过"
                                        type="sys_yes_no"
                                    />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="重修" prop="retake">
                            <dict-select
                                        v-model="form.retake"
                                        placeholder="请选择是否重修"
                                        type="sys_yes_no"
                                    />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注信息" prop="remark">
                            <el-input
                                v-model="form.remark"
                                placeholder="请输入备注信息"
                                clearable
                                type="textarea"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">返 回</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="upload.title"
            :visible.sync="upload.open"
            width="400px"
            append-to-body
        >
            <el-upload
                ref="upload"
                :limit="1"
                accept=".xlsx"
                :headers="upload.headers"
                :action="upload.url + '?update=' + upload.update"
                :disabled="upload.isUploading"
                :on-progress="handleImportProgress"
                :on-success="handleImportSuccess"
                :on-error="handleImportError"
                :auto-upload="false"
                drag
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                    将文件拖到此处，或
                    <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                    <el-checkbox
                        v-model="upload.update"
                    />是否更新已经存在的数据
                    <el-link
                        type="info"
                        style="font-size: 12px"
                        @click="handleImportTemplate"
                        >下载模板</el-link
                    >
                    <el-link
                        type="info"
                        style="font-size: 12px"
                        @click="handleImportReport"
                        >下载报告</el-link
                    >
                </div>
                <div class="el-upload__tip" style="color: red" slot="tip">
                    提示：仅允许导入“xlsx”格式文件！
                </div>
            </el-upload>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitImportForm"
                    >确 定</el-button
                >
                <el-button @click="upload.open = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Qs from "qs";
import { getAccessToken } from "@/utils/tokenTool";
import {
    listStuCurriculumScore,
    getStuCurriculumScore,
    addStuCurriculumScore,
    editStuCurriculumScore,
    delStuCurriculumScore,
} from "@/api/stuc/stu_curriculum_score";
export default {
    name: "stuc-stucurriculumscore-list",
    data() {
        return {
            tableToolbar: {
                perfect: false,
                zoom: true,
                custom: false,
                refresh: {
                    query: this.handleQuery,
                },
                slots: {
                    buttons: "toolbar_buttons",
                },
            },
            tableColumn: [
                { type: "checkbox", width: 60, fixed: "left" },
                {
                    field: "id",
                    title: "id",
                    minWidth: 120,
                    fixed: "left",
                    visible: false,
                },
                { field: "student_no", title: "学号", minWidth: 80 },
                { field: "student_name", title: "姓名", minWidth: 40 },
                { field: "turn_no", title: "学期", minWidth: 40 },
                { field: "category", title: "课程类别", minWidth: 80, formatter: this.dictFormat, dictType: "stuc_course_category" },
                { field: "course_no", title: "课程代码", minWidth: 80 },
                { field: "course_name", title: "课程名称", minWidth: 120 },
                { field: "credit", title: "学分", minWidth: 40 },
                { field: "score", title: "成绩", minWidth: 40 },
                { field: "level", title: "等级", minWidth: 40, formatter: this.dictFormat, dictType: "stuc_course_level" },
                { field: "pass", title: "通过", minWidth: 40, formatter: this.dictFormat, dictType: "sys_yes_no" },
                { field: "retake", title: "重修", minWidth: 40, formatter: this.dictFormat, dictType: "sys_yes_no" },
                {
                    field: "create_by",
                    title: "创建者",
                    minWidth: 120,
                    visible: false,
                },
                {
                    field: "create_time",
                    title: "创建时间",
                    minWidth: 120,
                    formatter: "formatDate",
                    visible: false,
                    form_type:3
                },
                {
                    field: "update_by",
                    title: "更新者",
                    minWidth: 120,
                    visible: false,
                },
                {
                    field: "update_time",
                    title: "更新时间",
                    minWidth: 120,
                    formatter: "formatDate",
                    form_type:3
                },
                { field: "remark", title: "备注信息", minWidth: 120 },
            ],
            loading: true,
            ids: [],
            single: true,
            multiple: true,
            total: 0,
            dataList: [],
            title: "",
            open: false,
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                id: undefined,
                dept_no: undefined,
                major_no: undefined,
                grade: undefined,
            },
            form: {},
            upload: {
                open: false,
                title: "",
                isUploading: false,
                update: false,
                headers: { Authorization: getAccessToken() },
                url: process.env.VUE_APP_BASE_API + "/stuc/stucurriculumscore/import",
            },
            rules: {
                student_no: [
                    {
                        required: true,
                        message: "学生不能为空",
                        trigger: "blur",
                    },
                ],
                turn_no: [
                    {
                        required: true,
                        message: "学期不能为空",
                        trigger: "blur",
                    },
                ],
                category: [
                    {
                        required: true,
                        message: "课程类别不能为空",
                        trigger: "blur",
                    },
                ],
                course_no: [
                    {
                        required: true,
                        message: "课程代码不能为空",
                        trigger: "blur",
                    },
                ],
                course_name: [
                    {
                        required: true,
                        message: "课程名称不能为空",
                        trigger: "blur",
                    },
                ],
                credit: [
                    {
                        required: true,
                        message: "学分不能为空",
                        trigger: "blur",
                    },
                ],
                score: [
                    {
                        required: true,
                        message: "成绩不能为空",
                        trigger: "blur",
                    },
                ],
                level: [
                    {
                        required: true,
                        message: "成绩等级不能为空",
                        trigger: "blur",
                    },
                ],
                pass: [
                    {
                        required: true,
                        message: "是否通过不能为空",
                        trigger: "blur",
                    },
                ],
                retake: [
                    {
                        required: true,
                        message: "是否重修不能为空",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    created() {
        this.getList();
    },
    methods: {
        //列表的筛选和排序
        tableChange(e) {},
        getList() {
            this.loading = true;
            this.ids = [];
            this.single = true;
            this.multiple = true;

            listStuCurriculumScore(this.queryParams).then((response) => {
                this.dataList = response.data.list;
                this.total = response.data.total;
                this.loading = false;
            });
        },

        dictFormat(e) {
            const col = this.tableColumn[e.columnIndex];
            if (col.dictData) {
                const values = e.cellValue ? e.cellValue.split(",") : [];
                const labels = [];
                for (let i = 0; i < values.length; i++) {
                    const v = values[i];
                    for (let j = 0; j < col.dictData.values.length; j++) {
                        const item = col.dictData.values[j];
                        if (v == item.key) {
                            labels.push(item.value);
                            break;
                        }
                    }
                }
                return labels.join(",");
            }
            return e.cellValue;
        },

        cancel() {
            this.open = false;
            this.reset();
        },

        reset() {
            this.form = {
                dept_no: undefined,
                major_no: undefined,
                grade: undefined,
            };
            this.resetForm("form");
        },

        handleQuery(e) {
           if(e){    this.queryParams = this.deepCopy(e);};
            this.queryParams.pageNum = 1;
            this.getList();
        },

        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },

        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加";
        },

        handleUpdate(row) {
            this.reset();
            const id = row.id || (this.ids.length > 0 ? this.ids[0] : "");
            getStuCurriculumScore(id).then((response) => {
                this.form = response.data;
                this.open = true;
                this.title = "修改";
            });
        },

        submitForm() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    if (this.form.id != null) {
                        editStuCurriculumScore(this.form).then((response) => {
                            if (response.code === 0) {
                                this.msgSuccess("修改成功");
                                this.open = false;
                                setTimeout(() => {
                                    this.getList();
                                }, 300);
                            }
                        });
                    } else {
                        addStuCurriculumScore(this.form).then((response) => {
                            if (response.code === 0) {
                                this.msgSuccess("新增成功");
                                this.open = false;
                                setTimeout(() => {
                                    this.getList();
                                }, 300);
                            }
                        });
                    }
                }
            });
        },

        handleDelete(row) {
            const ids =
                row.id || (this.ids.length > 0 ? this.ids.join(",") : "");
            this.$confirm('确定删除id为"' + ids + '"的数据项?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(function () {
                    return delStuCurriculumScore(ids);
                })
                .then(() => {
                    setTimeout(() => {
                        this.getList();
                    }, 300);
                    this.msgSuccess("删除成功");
                })
                .catch(function () {});
        },

        checkboxChangeEvent({ records }) {
            this.ids = records.map((item) => item.id);
            this.single = records.length != 1;
            this.multiple = !records.length;
        },

        handlePageChange({ currentPage, pageSize }) {
            if (this.queryParams.pageSize == pageSize) {
                this.getList();
            } else {
                this.queryParams.pageSize = pageSize;
                this.handleQuery();
            }
        },

        handleImport() {
            this.upload.title = "数据导入";
            this.upload.update = false;
            this.upload.open = true;
        },

        handleImportProgress(event, file, fileList) {
            this.upload.isUploading = true;
            if (event.percent == 100) {
                this.upload.open = false;
                this.upload.loading = this.$loading({
                    lock: true,
                    text: "正在导入数据",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
            }
        },

        handleImportSuccess(response, file, fileList) {
            console.log(response);
            if (this.upload.loading) {
                this.upload.loading.close();
            }
            this.upload.open = false;
            this.upload.isUploading = false;
            this.$refs.upload.clearFiles();
            if (response.code == 0) {
                const msg =
                    "导入成功" +
                    response.data.success_count +
                    "条数据，失败" +
                    response.data.fail_count +
                    "条数据" +
                    (response.data.msg ? "，" + response.data.msg : "");
                //this.$alert(msg, "提示", { dangerouslyUseHTMLString: true });
                this.$confirm(msg, "提示", {
                    distinguishCancelAndClose: true,
                    confirmButtonText: "确定",
                    cancelButtonText: "下载导入报告",
                })
                    .then(() => {})
                    .catch((action) => {
                        if (action === "cancel") {
                            // 下载导入报告
                            this.downloadbyurl("/stuc/stucurriculumscore/importReport");
                        }
                    });
            } else {
                this.$alert(response.msg, "提示", {
                    dangerouslyUseHTMLString: true,
                });
            }
            this.getList();
        },

        handleImportError(err, file, fileList) {
            if (this.upload.loading) {
                this.upload.loading.close();
            }
            this.upload.isUploading = false;
            this.$alert("导入失败", "提示", { dangerouslyUseHTMLString: true });
        },

        submitImportForm() {
            this.$refs.upload.submit();
        },

        handleImportTemplate() {
            this.downloadbyurl("/stuc/stucurriculumscore/importTemplate");
        },

        handleImportReport() {
            this.downloadbyurl("/stuc/stucurriculumscore/importReport");
        },

        handleExport() {
            this.$confirm("确定导出数据吗?", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.downloadbyurl(
                    "/stuc/stucurriculumscore/export?" + Qs.stringify(this.queryParams)
                );
            });
        },
    },
};
</script>
